import { ref } from "vue";
import { useStore } from "vuex";
import { AppService } from "@/services/app.service";
import { normalizeListFromApi } from "@/utils/normalizeListFromApi";

export function usePortalDealerApps() {
  const store = useStore();
  const apps = ref([]);
  const loading = ref(false);

  async function loadDealerApps() {
    loading.value = true;

    try {
      const response = await AppService.list();
      const list = normalizeListFromApi(response);
      apps.value = list;
    } catch (error) {
      console.warn("Portal dealer apps API unavailable.", error);
      apps.value = [];
    } finally {
      loading.value = false;
    }
  }

  async function requestAppAccess(appId) {
    const userId = store.getters.getMe?.plainId;
    if (!userId) {
      return;
    }

    try {
      await AppService.accessRequest({
        app_id: appId,
        user_id: userId,
      });
      await loadDealerApps();
    } catch (error) {
      console.error("Failed to request app access.", error);
    }
  }

  return {
    apps,
    loading,
    loadDealerApps,
    requestAppAccess,
  };
}
